import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import { useGetInsightWidgetData } from '~/services/insights/insights-service';
import { InsightIconsRoot } from '~/views/insights/components/insight-icons-root/InsightIconsRoot';
import { LegacyInsightsDrawerContent } from '~/widgets/insight-widget/components/insight-drawer/components/insights-drawer-content/LegacyInsightsDrawerContent';

import { IconConfig } from '../ScenarioInsightsLegacyDrawer';
import styles from './InsightsInfo.module.scss';

export interface InsightsInfoProps {
  insightId: string | null;
  iconConfig?: IconConfig;
}

export const InsightsInfo = ({ insightId, iconConfig }: InsightsInfoProps) => {
  const { data, isLoading } = useGetInsightWidgetData(insightId as string);

  if (isLoading) {
    return (
      <div className={styles.loadingWrapper} data-testid="insight-info-loading">
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: 40,
              },
            },
          ]}
        />
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: 72,
              },
            },
          ]}
        />
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: 312,
              },
            },
          ]}
        />
      </div>
    );
  }

  if (!data?.data?.insight) {
    return (
      <div className={styles.wrapper}>
        <img
          className={styles.image}
          alt=""
          src="/app/static/images/empty-state/radio-telescope.png"
        />
      </div>
    );
  }

  return (
    <LegacyInsightsDrawerContent
      insightsData={data.data}
      showEntityHeader={false}
      header={() => (
        <div className={styles.header}>
          {iconConfig && <InsightIconsRoot {...iconConfig} isStarred={false} />}
          <h3 className={styles.title}>{data.data.insight.simple_title}</h3>
        </div>
      )}
    />
  );
};
